import { BulkXRITMRequest } from "@/api/backofficeRest/generated/model"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"

export interface IBulkSmartReadsUploadMutator {
  uploadBulkFile(onSuccessFn, onErrorFn): MutationResult<Array<string>>
}

class BulkSmartReadsUploadMutatorClass implements IBulkSmartReadsUploadMutator {
  uploadBulkFile(onSuccessFn, onErrorFn): MutationResult<Array<string>> {
    return useMutation({
      ...BackofficeRestMutations.meterpoints.bulkSmartReads(),
      serializerFn: (data: Array<string>): BulkXRITMRequest => ({
        mpxns: data,
      }),
      onSuccessFn,
      onErrorFn,
    })
  }
}

export const BulkSmartReadsUploadMutator =
  new BulkSmartReadsUploadMutatorClass()
